import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query billingProductOptions($businessId: ID!) {
    billingZuoraProductOptions(businessId: $businessId) {
      currency
      upgradeSequences {
        name
        upgrades {
          name
          id
          recurringChargeId
          usageChargeId
          pricePerSeatPerMonth
          regions
        }
        regions
      }
      newProducts {
        name
        id
        pricePerSeatPerMonth
        recurringChargeId
        usageChargeId
        regions
        uncounted
        discount {
          recurringChargeId
          percentage
          duration
        }
      }
      platformBillingPeriod
    }
  }
`

export const billingProductOptionsKey = getQueryNames(query)[0]

export default query
